<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="col-md-12">
          <ol class="breadcrumb breadcrumb-card-header pull-left">
            <li class="breadcrumb-item">
              <a href="javascript:void(0);" @click="backParent"> Branch</a>
            </li>
            <li class="breadcrumb-item active">
              <span v-if="branch.id === null">New</span>
              <span v-else>
                {{ branch.branch_no }}
              </span>
            </li>
          </ol>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group row">
              <label for="name" class="col-sm-3 col-form-label text-left">Branch Number</label>
              <div class="col-sm-9">
                <input type="text" v-model="branch.branch_no" class="form-control"/>
              </div>
            </div>
            <div class="form-group row">
              <label for="name" class="col-sm-3 col-form-label text-left">Organization</label>
              <div class="col-sm-9">
                <select v-model="branch.org_id" class="form-control">
                  <option v-for="o in organizationList" :key="o.id" :value="o.id">{{ o.name }}</option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label for="name" class="col-sm-3 col-form-label text-left">Name</label>
              <div class="col-sm-9">
                <input type="text" v-model="branch.name" class="form-control"/>
              </div>
            </div>
            <div class="form-group row">
              <label for="address" class="col-sm-3 col-form-label text-left">Address</label>
              <div class="col-sm-9">
                <textarea rows="5" v-model="branch.address" class="form-control"></textarea>
              </div>
            </div>
            <div class="form-group row">
              <label for="phone" class="col-sm-3 col-form-label text-left">Phone</label>
              <div class="col-sm-9">
                <input type="text" v-model="branch.phone" class="form-control"/>
              </div>
            </div>
            <div class="form-group row">
              <label for="email" class="col-sm-3 col-form-label text-left">Email</label>
              <div class="col-sm-9">
                <input type="text" class="form-control" v-model="branch.email"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <button type="button" @click="backParent" class="btn btn-sm btn-danger pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
        <button type="button" @click="createBranch" class="btn btn-sm btn-primary pull-right" v-if="branch.id === null"><i class="fa fa-check" aria-hidden="true"></i> Save</button>
        <button type="button" @click="updateBranch" class="btn btn-sm btn-primary pull-right" v-else><i class="fa fa-save" aria-hidden="true"></i> Update</button>
      </div>
    </div>
    <pre>
      <!-- {{ organizationList}} -->
      <!-- {{ branch }} -->
    </pre>
  </div>
</template>

<script>
import Axios from 'axios'
import { mapState } from 'vuex'
import { getHeader, branchUrl } from '../../config'

export default {
  name: 'BranchForm',
  props: ['branch'],
  computed: {
    ...mapState({
      organizationList: state => state.organizations.organizationList
    })
  },
  methods: {
    backParent: function () {
      this.$emit('backClicked')
    },
    updateBranch: function () {
      Axios.put(branchUrl + '/' + this.branch.id, this.branch, { headers: getHeader() })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
          this.$emit('backClicked')
        })
        .catch(error => {
          this.$swal(
            'Error',
            '<pre>' + error.response + '</pre>',
            'error'
          )
        })
    },
    createBranch: function () {
      Axios.post(branchUrl, this.branch, { headers: getHeader() })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
          this.$emit('backClicked')
        })
        .catch(error => {
          this.$swal(
            'Error',
            '<pre>' + error.response + '</pre>',
            'error'
          )
        })
    }
  }
}
</script>
